import { createTheme } from "@mui/material/styles";
import { theme } from "@piiqtechnologies/ui-components";
const customTheme = createTheme(theme, {});
export default customTheme;
